











import { defineComponent, ref } from "@vue/composition-api";

export default defineComponent({
  name: "ScreenControls",
  setup(_, { emit }) {
    const screen = ref<HTMLDivElement | undefined>();
    let startEvent = 0;
    let startPosition = -1;
    const eventHandler = (e: TouchEvent | PointerEvent) => {
      if (!screen.value || !e) return;
      if (["pointerdown"].includes(e.type)) {
        emit("pause");
        startEvent = e.timeStamp;
        startPosition = "clientX" in e ? e.clientX : e.changedTouches[0].clientX;
      }
      if (["pointerup", "touchend"].includes(e.type)) {
        if (!startEvent || !(e.timeStamp - startEvent)) return;
        const { left, width } = screen.value.getBoundingClientRect();
        const halfScreen = left + width / 2;
        const eventOffsetLeft = "clientX" in e ? e.clientX : e.changedTouches[0].clientX;
        if (e.type === "pointerup") {
          if (e.timeStamp - startEvent > 200) {
            emit("play");
            startEvent = 0;
          } else {
            if (eventOffsetLeft > halfScreen) {
              emit("next");
            } else {
              emit("prev");
            }
          }
          startPosition = -1;
        } else if (e.type === "touchend") {
          if (startPosition > 0 && startPosition > halfScreen && eventOffsetLeft < halfScreen) {
            emit("next-user");
            startPosition = -1;
          } else if (startPosition > 0 && startPosition < halfScreen && eventOffsetLeft > halfScreen) {
            emit("prev-user");
            startPosition = -1;
          }
        }
      }
    };

    return {
      eventHandler,
      screen,
    };
  },
});
